<template>
  <div class="Landing2">
    <div class="page-loader" :class="{ 'page-loader--done': !isLoading }">
      <img :src="loaderLogo" alt="SoonForward" class="loader-logo" />
      <div class="loader-bar">
        <div class="loader-bar-fill" :style="{ width: loadProgress + '%' }"></div>
      </div>
    </div>

    <Landing2Navbar />

    <Landing2Hero @video-stage="onVideoStage" />

    <Landing2Partners />

    <div id="approach">
      <Landing2ApproachDesktop />
      <Landing2ApproachMobile />
    </div>

    <Landing2Vision />

    <Landing2Booking />

    <Landing2Footer />
  </div>
</template>

<script>
import loaderLogo from '../assets/landing2/FinalLogo.png';
import '../assets/styles/landing-shared.scss';
import Landing2Navbar from '../components/Landing2Navbar.vue';
import Landing2Hero from '../components/Landing2Hero.vue';
import Landing2Partners from '../components/Landing2Partners.vue';
import Landing2ApproachDesktop from '../components/Landing2ApproachDesktop.vue';
import Landing2ApproachMobile from '../components/Landing2ApproachMobile.vue';
import Landing2Vision from '../components/Landing2Vision.vue';
import Landing2Booking from '../components/Landing2Booking.vue';
import Landing2Footer from '../components/Landing2Footer.vue';

export default {
  name: 'Landing2',
  components: {
    Landing2Navbar,
    Landing2Hero,
    Landing2Partners,
    Landing2ApproachDesktop,
    Landing2ApproachMobile,
    Landing2Vision,
    Landing2Booking,
    Landing2Footer,
  },
  data() {
    return {
      isLoading: true,
      loadProgress: 0,
      loaderLogo,
    };
  },
  mounted() {
    this.updateBodyBackground();
    window.addEventListener('resize', this.updateBodyBackground);
    // safety net in case the video's events never fire
    this.loadingTimeout = setTimeout(() => {
      this.finishLoading();
    }, 5000);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateBodyBackground);
    document.getElementById('app').style.background = '';
    document.documentElement.style.background = '';
    clearTimeout(this.loadingTimeout);
  },
  methods: {
    updateBodyBackground() {
      // white on mobile so brief translateY during their scroll-reveal
      // doesn't flash the gray body bg through the gap
      const bg = window.innerWidth < 1440 ? '#FFFFFF' : '#F7F6F8';
      document.getElementById('app').style.background = bg;
      document.documentElement.style.background = bg;
    },
    onVideoStage(stage) {
      const stageProgress = {
        loadstart: 15,
        loadedmetadata: 45,
        loadeddata: 75,
        canplaythrough: 100,
      };
      const value = stageProgress[stage];
      if (value === undefined) return;
      this.loadProgress = Math.max(this.loadProgress, value);
      if (stage === 'canplaythrough') {
        this.finishLoading();
      }
    },
    finishLoading() {
      if (!this.isLoading) return;
      clearTimeout(this.loadingTimeout);
      this.loadProgress = 100;
      setTimeout(() => {
        this.isLoading = false;
      }, 300);
    },
  },
};
</script>

<style scoped>
/* -----------
   Page loader
   ----------- */

.page-loader {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.5rem;
  background: #FFFFFF;
  opacity: 1;
  visibility: visible;
  transition: opacity 0.5s ease, visibility 0s linear 0s;
}

.page-loader--done {
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.5s ease, visibility 0s linear 0.5s;
}

.loader-logo {
  width: 3rem;
  height: auto;
}

.loader-bar {
  width: 16rem;
  height: 0.75rem;
  overflow: hidden;
  background: var(--color-card-bg);
  border: 1px solid var(--color-text-muted);
  border-radius: 999px;
}

.loader-bar-fill {
  width: 0;
  height: 100%;
  background: var(--color-primary);
  transition: width 0.4s ease;
}

/* -----------
   Mobile (<768px)
   ----------- */

@media (max-width: 767px) {
  .Landing2 > *:not(.site-header) {
    display: none;
  }

  .Landing2 > .page-loader {
    display: flex;
  }

  .Landing2 > .hero {
    display: block;
  }

  .Landing2 > .partners {
    display: flex;
  }

  .Landing2 > #approach {
    display: block;
  }

  .Landing2 > .vision {
    display: flex;
  }

  .Landing2 > .booking {
    display: flex;
  }

  .Landing2 > .footer {
    display: flex;
  }
}

/* -----------
   Portrait (768px-1439px)
   ----------- */

@media (min-width: 768px) and (max-width: 1439px) {
  .Landing2 > *:not(.site-header) {
    display: none;
  }

  .Landing2 > .page-loader {
    display: flex;
  }

  .Landing2 > .hero {
    display: block;
  }

  .Landing2 > .partners {
    display: flex;
  }

  .Landing2 > #approach {
    display: block;
  }

  .Landing2 > .vision {
    display: flex;
  }

  .Landing2 > .booking {
    display: flex;
  }

  .Landing2 > .footer {
    display: flex;
  }
}
</style>
